import { render, staticRenderFns } from "./ExpenseNotesField.vue?vue&type=template&id=09357016&"
import script from "./ExpenseNotesField.vue?vue&type=script&lang=js&"
export * from "./ExpenseNotesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09357016')) {
      api.createRecord('09357016', component.options)
    } else {
      api.reload('09357016', component.options)
    }
    module.hot.accept("./ExpenseNotesField.vue?vue&type=template&id=09357016&", function () {
      api.rerender('09357016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/expenses/fields/ExpenseNotesField.vue"
export default component.exports